import type { TranslationKey } from "./en.js";

// German is first-class (DESIGN §6) — real strings, designed to the longer width.
export const de: Record<TranslationKey, string> = {
  "nav.inbox": "Eingang",
  "nav.today": "Heute",
  "nav.upcoming": "Demnächst",
  "nav.anytime": "Irgendwann",
  "nav.someday": "Vielleicht",
  "nav.logbook": "Logbuch",
  "nav.assigned": "Mir zugewiesen",

  "section.projects": "Projekte",
  "section.thisEvening": "Heute Abend",

  "empty.inbox": "Eingang leer.",
  "empty.today": "Alles erledigt.",
  "empty.upcoming": "Nichts geplant.",
  "empty.anytime": "Nichts wartet.",
  "empty.someday": "Noch keine Ideen.",
  "empty.logbook": "Noch nichts protokolliert.",
  "empty.assigned": "Dir ist nichts zugewiesen.",
  "empty.project": "Hier ist noch nichts.",

  "sync.synced": "Synchron",
  "sync.syncing": "Synchronisiere…",
  "sync.offline": "Offline — lokal gespeichert",
  "sync.error": "Sync fehlgeschlagen",
  "sync.rejected": "{n} Änderung(en) wurden vom Server abgelehnt und zurückgenommen.",

  "quickadd.placeholder": "Aufgabe hinzufügen — Datum, #Projekt, @Label, !p1",
  "quickadd.hint": "Enter zum Hinzufügen · Esc zum Schließen",
  "quickadd.add": "Hinzufügen",

  "toolbar.search": "Suchen",

  "detail.notes": "Notizen",
  "detail.notesPlaceholder": "Notizen hinzufügen…",
  "detail.startDate": "Startdatum",
  "detail.evening": "Heute Abend",
  "detail.deadline": "Frist",
  "detail.priority": "Priorität",
  "detail.labels": "Labels",
  "detail.project": "Projekt",
  "detail.section": "Abschnitt",
  "detail.someday": "Vielleicht",
  "detail.delete": "Aufgabe löschen",
  "detail.recurrence": "Wiederholung",
  "detail.noProject": "Eingang",
  "detail.noSection": "Kein Abschnitt",
  "detail.datePlaceholder": "z. B. morgen, nächsten Di, 31.7.",
  "detail.clear": "Löschen",
  "detail.reminder": "Erinnere mich",
  "detail.reminderPlaceholder": "z. B. morgen 9 Uhr",
  "detail.reminderClear": "Erinnerung löschen",
  "detail.assignee": "Zuständig",
  "detail.assignNobody": "Niemand",
  "detail.assignMe": "Mir zuweisen",
  "detail.metaCreated": "Erstellt",
  "detail.metaChanged": "Geändert",
  "detail.metaCompleted": "Erledigt",

  "detail.fullscreen": "Vollbild öffnen",

  "fullscreen.close": "Vollbild schließen",
  "fullscreen.noNotes": "Keine Notizen.",
  "fullscreen.notFound": "Diese Aufgabe ist hier nicht vorhanden.",

  "assign.me": "Ich",

  "comments.title": "Kommentare",
  "comments.empty": "Noch keine Kommentare.",
  "comments.placeholder": "Kommentar schreiben…",
  "comments.hint": "Enter zum Senden · Shift+Enter für neue Zeile",
  "comments.send": "Senden",
  "comments.edit": "Kommentar bearbeiten",
  "comments.delete": "Kommentar löschen",
  "comments.save": "Speichern",
  "comments.edited": "bearbeitet",
  "comments.deleteConfirm": "Diesen Kommentar löschen?",

  "attachment.title": "Anhänge",
  "attachment.add": "Anhang hinzufügen",
  "attachment.delete": "Anhang löschen",
  "attachment.deleteConfirm": "Diesen Anhang löschen?",
  "attachment.uploadError": "Upload fehlgeschlagen. Prüfe Verbindung und Dateigröße.",
  "attachment.downloadError": "Download fehlgeschlagen. Prüfe deine Verbindung.",

  "time.justNow": "gerade eben",

  "priority.none": "Keine",
  "priority.p1": "P1",
  "priority.p2": "P2",
  "priority.p3": "P3",

  "settings.title": "Einstellungen",
  "settings.account": "Konto",
  "settings.appearance": "Darstellung",
  "settings.workspace": "Workspace",
  "settings.members": "Mitglieder",
  "settings.notifications": "Benachrichtigungen",
  "settings.mcp": "Claude / MCP",
  "settings.name": "Name",
  "settings.locale": "Sprache",
  "settings.theme": "Design",
  "settings.logout": "Abmelden",
  "settings.save": "Speichern",

  "palette.placeholder": "Aufgaben, Projekte suchen oder Befehl eingeben…",
  "palette.groupTasks": "Aufgaben",
  "palette.groupProjects": "Projekte",
  "palette.groupLabels": "Labels",
  "palette.groupCommands": "Befehle",
  "palette.empty": "Keine Treffer.",
  "palette.hint": "↑↓ bewegen · ↵ öffnen · Esc schließen",
  "cmd.newTask": "Neue Aufgabe",
  "cmd.newProject": "Neues Projekt",
  "cmd.cycleTheme": "Design wechseln",
  "cmd.settings": "Einstellungen öffnen",
  "cmd.logout": "Abmelden",
  "cmd.goto": "Gehe zu {name}",

  "members.title": "Mitglieder",
  "members.you": "Du",
  "members.role.owner": "Eigentümer",
  "members.role.admin": "Admin",
  "members.role.member": "Mitglied",
  "members.role.viewer": "Betrachter",
  "members.remove": "Entfernen",
  "members.leave": "Workspace verlassen",
  "members.removeConfirm": "{name} aus diesem Workspace entfernen?",
  "members.leaveConfirm": "Diesen Workspace verlassen?",
  "members.lastOwner": "Ein Workspace braucht mindestens eine Inhaberin oder einen Inhaber.",
  "members.forbidden": "Du darfst diese Mitgliedschaft nicht ändern.",
  "members.pending": "Offene Einladungen",
  "members.noPending": "Keine offenen Einladungen.",
  "members.invite": "Personen einladen",
  "members.inviteRole": "Rolle",
  "members.emailOptional": "E-Mail (optional)",
  "members.createLink": "Einladungslink erstellen",
  "members.revoke": "Widerrufen",
  "members.copyLink": "Link kopieren",
  "members.copied": "Link kopiert",
  "members.expires": "Läuft ab am {date}",
  "members.readonlyHint": "Du hast Betrachter-Zugriff — Änderungen sind schreibgeschützt.",

  "invite.title": "Du bist eingeladen",
  "invite.body": "Tritt diesem Workspace auf Balu bei.",
  "invite.signInFirst": "Melde dich an oder erstelle ein Konto, um beizutreten.",
  "invite.accept": "Einladung annehmen",
  "invite.accepting": "Trete bei…",
  "invite.joined": "Willkommen im Workspace",
  "invite.invalidTitle": "Einladung ungültig",
  "invite.invalidBody": "Dieser Link ist abgelaufen oder wurde widerrufen. Bitte um einen neuen.",
  "invite.back": "Zurück zu Balu",

  "workspace.switch": "Workspace wechseln",
  "workspace.new": "Neuer Workspace",
  "workspace.newName": "Workspace-Name",
  "workspace.create": "Erstellen",
  "workspace.delete": "Workspace löschen",
  "workspace.deletePrompt": "Das löscht den Workspace mit allen Projekten, Aufgaben und Kommentaren unwiderruflich. Gib den Namen des Workspace zur Bestätigung ein.",
  "workspace.deleted": "Workspace gelöscht",
  "workspace.deleteNameMismatch": "Der Name stimmt nicht überein.",

  "channels.subtitle": "Wohin Erinnerungen gehen. Pro Konto konfiguriert.",
  "channels.add": "Kanal hinzufügen",
  "channels.none": "Noch keine Kanäle.",
  "channels.type.ntfy": "ntfy",
  "channels.type.email": "E-Mail",
  "channels.type.telegram": "Telegram",
  "channels.ntfyUrl": "ntfy-Topic-URL",
  "channels.emailAddress": "E-Mail-Adresse",
  "channels.telegramChatId": "Telegram-Chat-ID",
  "channels.test": "Test senden",
  "channels.tested": "Testnachricht gesendet",
  "channels.unavailable": "Dieser Server hat keinen {type}-Transport konfiguriert.",
  "channels.remove": "Kanal entfernen",
  "channels.save": "Kanäle speichern",
  "channels.saved": "Kanäle gespeichert",

  "mcp.subtitle": "Claude Code (oder einen anderen MCP-Client) mit diesem Server verbinden und Aufgaben verwalten lassen.",
  "mcp.endpoint": "MCP-Endpunkt",
  "mcp.key": "Auth-Key",
  "mcp.reveal": "Key anzeigen",
  "mcp.hide": "Key verbergen",
  "mcp.hint": "In Claude Code hinzufügen:",
  "mcp.noKey": "Noch kein Key. Erzeuge einen, um einen Client zu verbinden.",
  "mcp.generate": "Key erzeugen",
  "mcp.generated": "Key erzeugt",
  "mcp.regenerate": "Neuen Key erzeugen",
  "mcp.regenerateHint": "Alles, was mit dem alten Key verbunden ist, funktioniert danach nicht mehr.",
  "mcp.regenerateConfirm": "Neuen Key erzeugen? Jeder Client mit dem alten Key verliert sofort den Zugriff.",
  "mcp.regenerated": "Neuer Key erzeugt",

  "theme.system": "System",
  "theme.light": "Hell",
  "theme.dark": "Dunkel",

  "auth.loginTitle": "Willkommen zurück",
  "auth.registerTitle": "Konto erstellen",
  "auth.tagline": "die selbst-hostbare To-do-App.",
  "auth.email": "E-Mail",
  "auth.password": "Passwort",
  "auth.name": "Name",
  "auth.login": "Anmelden",
  "auth.register": "Registrieren",
  "auth.toRegister": "Noch kein Konto? Registrieren",
  "auth.toLogin": "Schon ein Konto? Anmelden",
  "auth.rate_limited": "Zu viele Versuche. Bitte kurz warten und erneut versuchen.",
  "auth.errorGeneric": "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
  "auth.invalid_credentials": "E-Mail oder Passwort ist falsch.",
  "auth.email_taken": "Diese E-Mail ist bereits registriert.",
  "auth.registration_disabled": "Registrierung ist auf diesem Server deaktiviert.",

  "project.newProject": "Neues Projekt",
  "project.newProjectName": "Projektname",
  "project.addSection": "Abschnitt hinzufügen",
  "project.sectionName": "Abschnittsname",
  "project.deleteSection": "Abschnitt löschen",
  "project.deleteSectionConfirm": "Diesen Abschnitt löschen? Die Aufgaben bleiben erhalten und werden aus dem Abschnitt gelöst.",
  "project.actions": "Projektaktionen",
  "project.rename": "Umbenennen",
  "project.color": "Farbe",
  "project.archive": "Archivieren",
  "project.unarchive": "Archivierung aufheben",
  "project.archived": "Archiviert",
  "project.archivedSuffix": "(archiviert)",
  "project.archivedProjects": "Archivierte Projekte",
  "project.delete": "Projekt löschen",
  "project.deleteConfirm": "„{name}“ und die {count} offenen Aufgaben darin löschen? Das lässt sich nicht rückgängig machen.",
  "project.deleteConfirmOne": "„{name}“ und die eine offene Aufgabe darin löschen? Das lässt sich nicht rückgängig machen.",
  "project.deleteConfirmEmpty": "„{name}“ löschen? Das lässt sich nicht rückgängig machen.",

  // Screenreader-Ankündigungen für Drag & Drop; ein erfolgreicher Move bleibt
  // sonst still (Ablehnungen meldet sync.rejected).
  "dnd.pickedUp": "{title} aufgenommen",
  "dnd.projectPickedUp": "Projekt {name} aufgenommen",
  "dnd.overTarget": "Über {target}",
  "dnd.overGeneric": "Über einer Liste",
  "dnd.droppedTarget": "In {target} verschoben",
  "dnd.staleTarget": "Die Aufgabe oder ihr Ziel existiert nicht mehr.",
  "dnd.dropped": "Aufgabe abgelegt",
  "dnd.projectDropped": "Projekt abgelegt",
  "dnd.cancelled": "Verschieben abgebrochen",

  "date.today": "Heute",
  "date.tomorrow": "Morgen",
  "date.yesterday": "Gestern",
  "date.overdue": "Überfällig",

  "common.cancel": "Abbrechen",
  "common.later": "Später diese Woche",
  "common.copy": "Kopieren",
  "common.copied": "Kopiert",
  "common.confirm": "Bestätigen",
  "common.remove": "Entfernen",
};
